import { render, staticRenderFns } from "./todo-main.vue?vue&type=template&id=0103f2a1&"
import script from "./todo-main.vue?vue&type=script&lang=ts&"
export * from "./todo-main.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports